import { render } from "./LandingBlockBetterWay.vue?vue&type=template&id=53ea031a&scoped=true&lang=pug"
import script from "./LandingBlockBetterWay.vue?vue&type=script&lang=js"
export * from "./LandingBlockBetterWay.vue?vue&type=script&lang=js"

import "./LandingBlockBetterWay.vue?vue&type=style&index=0&id=53ea031a&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ea031a"]])

export default __exports__